import { css } from '@emotion/css';

export const swimlaneGroupStyle = css({
  display: 'flex',
  flexDirection: 'column',
  borderBottom: '1px solid var(--streamlain-border-color)',
});

export const swimlaneHeaderStyle = css({
  position: 'sticky',
  left: 0,
  zIndex: 3,
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  padding: '6px 10px',
  background: 'var(--streamlain-background-secondary-color)',
  fontSize: '12px',
  fontWeight: 600,
  color: 'var(--streamlain-text-primary-color)',
  cursor: 'pointer',
  userSelect: 'none',
});

export const swimlaneHeaderCollapsedStyle = css({
  opacity: 0.8,
});

export const swimlaneBodyStyle = css({
  position: 'relative',
});

export const swimlaneCountStyle = css({
  color: 'var(--streamlain-text-secondary-color)',
  fontWeight: 400,
});
